const SELECT_CUSTOMER = `
  SELECT
    customer.resource_name,
    customer.id,
    customer.descriptive_name,
    customer.currency_code
  FROM
    customer
`

const SELECT_CUSTOMER_CLIENT = `
  SELECT
    customer_client.resource_name,
    customer_client.client_customer,
    customer_client.hidden,
    customer_client.level
  FROM
    customer_client
`

const SELECT_CAMPAIGN = `
  SELECT
    customer.id,
    campaign.resource_name,
    campaign.id,
    campaign.name,
    campaign.status,
    campaign.start_date,
    campaign.end_date
  FROM
    campaign
  WHERE
    campaign.status = ENABLED
`

const SELECT_BUDGET = `
  SELECT
    customer.id,
    campaign_budget.name,
    campaign_budget.id,
    campaign_budget.status
  FROM
    campaign_budget
  WHERE
    campaign_budget.status = ENABLED
`

const SELECT_AD_GROUP = `
  SELECT
    customer.id,
    ad_group.resource_name,
    ad_group.id,
    ad_group.name,
    ad_group.status,
    ad_group.type,
    campaign.id,
    campaign.name
  FROM
    ad_group
  WHERE
    ad_group.status = ENABLED
`

const SELECT_AD_GROUP_AD = `
  SELECT
    customer.id,
    ad_group.id,
    ad_group.name,
    ad_group_ad.resource_name,
    ad_group_ad.status,
    ad_group_ad.ad.id,
    ad_group_ad.ad.type,
    ad_group_ad.ad.final_urls,
    ad_group_ad.ad.display_url,
    ad_group_ad.ad.expanded_text_ad.headline_part1,
    ad_group_ad.ad.expanded_text_ad.headline_part2,
    ad_group_ad.ad.expanded_text_ad.headline_part3,
    ad_group_ad.ad.expanded_text_ad.description,
    ad_group_ad.ad.expanded_text_ad.description2,
    ad_group_ad.ad.expanded_text_ad.path1,
    ad_group_ad.ad.expanded_text_ad.path2,
    ad_group_ad.ad.responsive_search_ad.headlines,
    ad_group_ad.ad.responsive_search_ad.descriptions,
    ad_group_ad.ad.responsive_search_ad.path1,
    ad_group_ad.ad.responsive_search_ad.path2,
    metrics.average_cpc,
    metrics.clicks,
    metrics.ctr,
    metrics.cost_micros,
    metrics.impressions
  FROM
    ad_group_ad
  WHERE
    ad_group_ad.status = ENABLED
`

const SELECT_AD_GROUP_KEYWORD = `
  SELECT
    customer.id,
    ad_group.id,
    ad_group.name,
    ad_group_criterion.resource_name,
    ad_group_criterion.criterion_id,
    ad_group_criterion.status,
    ad_group_criterion.final_urls,
    ad_group_criterion.keyword.text,
    ad_group_criterion.keyword.match_type,
    metrics.average_cpc,
    metrics.clicks,
    metrics.ctr,
    metrics.cost_micros,
    metrics.impressions
  FROM
    keyword_view
  WHERE
    ad_group_criterion.status = ENABLED
    AND ad_group_criterion.type = KEYWORD
`

export default {
  SELECT_CUSTOMER,
  SELECT_CUSTOMER_CLIENT,
  SELECT_CAMPAIGN,
  SELECT_BUDGET,
  SELECT_AD_GROUP,
  SELECT_AD_GROUP_AD,
  SELECT_AD_GROUP_KEYWORD
}
